export default __webpack_public_path__ + "fonts/la-solid-900.woff2";